export enum EmergencyTriageLevelEnum {
  Level1 = 1,
  Level2 = 2,
  Level3 = 3
}

export const EmergencyTriageLevelOptions = [
{ id: 1, label: 'High Priority' },
{ id: 2, label: 'Moderate Priority' },
{ id: 3, label: 'Low Priority' }
];
